import { IconStateInformation } from "@/assets/icons/figma/IconStateInformation";
import { usePromotionCopy } from "@/features/promotions/hooks/usePromotionCopy";
import type { PromotionPresentation } from "@/features/promotions/types";
import * as Popover from "@radix-ui/react-popover";

/** The disclosure is separate from the listing link and never records a product click. */
export const PromotionDisclosure = ({
  disclosure,
}: Pick<PromotionPresentation, "disclosure">) => {
  const { copy } = usePromotionCopy();
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          className="mt-1 flex min-h-11 items-center gap-1.5 rounded-[4px] text-xs text-grey-700 underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-curious-200"
        >
          {copy("sponsored")}
          <IconStateInformation aria-hidden className="size-3.5" />
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          aria-label={copy("reason")}
          align="start"
          sideOffset={4}
          collisionPadding={16}
          className="z-[110] w-72 max-w-[calc(100vw-2rem)] rounded-[4px] border border-grey-200 bg-white p-4 font-body text-sm text-black shadow-lg"
        >
          <p className="mb-2 mt-0 font-title font-bold">
            {copy("advertiser", { name: disclosure.advertiserName })}
          </p>
          <p className="m-0 text-sm leading-relaxed text-grey-700">
            {disclosure.reason}
          </p>
          <Popover.Close className="mt-3 min-h-11 text-sm font-bold text-brand-500 underline underline-offset-4">
            {copy("close")}
          </Popover.Close>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
